import React, { FC } from 'react';

import { Flex, Text } from '@adsk/alloy-react-box';
import { LinkButton } from '@adsk/alloy-react-button';
import { AlertWarningIcon } from '@adsk/alloy-react-icon';
import theme from '@adsk/alloy-react-theme';

import { useTranslation } from '../i18n';

interface EntityPickerModalLoadMoreErrorProps {
  onTryAgain: () => void;
}

const EntityPickerModalLoadMoreError: FC<
  EntityPickerModalLoadMoreErrorProps
> = ({ onTryAgain }) => {
  const { t } = useTranslation();
  return (
    <Flex alignItems="center" height="68px" paddingLeft="50px">
      <AlertWarningIcon
        style={{
          color: theme.colors.charcoal700,
        }}
      />
      <Text
        typography="bodySmall"
        color="charcoal700"
        marginLeft="12px"
        marginRight="8px"
      >
        {t('ERROR_LOADING_RESULTS')}
      </Text>
      <LinkButton onClick={onTryAgain} style={theme.typography.bodySmall}>
        {t('TRY_AGAIN')}
      </LinkButton>
    </Flex>
  );
};

export default EntityPickerModalLoadMoreError;
